import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

var calcX = function calcX(clientX, tooltipWidth, windowWidth) {
  var offsetX = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var sum = clientX + tooltipWidth + offsetX;
  var x = sum > windowWidth ? clientX - (sum - windowWidth) : clientX;
  return x;
};

var calcXRevert = function calcXRevert(clientX, tooltipWidth, windowWidth) {
  var offsetX = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var sum = clientX + tooltipWidth + offsetX;
  var leftEdge = 0 + offsetX;
  if (sum > windowWidth) {
    return clientX - tooltipWidth > leftEdge ? clientX - tooltipWidth : leftEdge;
  }
  return clientX;
};

var calcY = function calcY(clientY, tooltipHeight, windowHeight) {
  var offsetY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var sum = clientY + tooltipHeight + offsetY;
  var y = sum > windowHeight ? clientY - (sum - windowHeight) : clientY;
  return y;
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_tooltip__3lL_d {\n  position: fixed;\n  pointer-events: none;\n}\n";
var styles = { "tooltip": "styles_tooltip__3lL_d" };
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Tooltip = function (_Component) {
  inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false,
      x: 0,
      y: 0
    }, _this.tooltipRoot = document.getElementById('tooltip-root'), _this.el = document.createElement('div'), _this.tooltipRef = React.createRef(), _this.handleMouseOver = function (event) {
      _this.setState({ show: true });
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ show: false });
    }, _this.handleMouseMove = function (event) {
      var offset = _this.props.offset;
      var clientX = event.clientX,
          clientY = event.clientY;

      var _this$getTooltipPosit = _this.getTooltipPosition(clientX, clientY, offset),
          x = _this$getTooltipPosit.x,
          y = _this$getTooltipPosit.y;

      _this.setState({ x: x, y: y });
    }, _this.getTooltipPosition = function (clientX, clientY) {
      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var isRevert = _this.props.isRevert;

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var tooltipWidth = _this.tooltipRef.current.getBoundingClientRect().width;
      var tooltipHeight = _this.tooltipRef.current.getBoundingClientRect().height;
      var x = isRevert ? calcXRevert(clientX, tooltipWidth, windowWidth, offset) : calcX(clientX, tooltipWidth, windowWidth, offset);
      var y = calcY(clientY, tooltipHeight, windowHeight, offset);
      return { x: x, y: y };
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.tooltipRoot.appendChild(this.el);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.tooltipRoot.removeChild(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          show = _state.show,
          x = _state.x,
          y = _state.y;
      var _props = this.props,
          tooltipElement = _props.tooltipElement,
          disable = _props.disable,
          children = _props.children,
          className = _props.className,
          style = _props.style;


      if (disable) return children;

      var tooltip = React.createElement(
        'div',
        {
          ref: this.tooltipRef,
          className: styles.tooltip,
          style: { left: x, top: y },
          'data-test': 'component-tooltip'
        },
        tooltipElement()
      );

      return React.createElement(
        Fragment,
        null,
        show && ReactDOM.createPortal(tooltip, this.el),
        React.createElement(
          'div',
          {
            'data-test': 'component-children-wrapper',
            onMouseOver: this.handleMouseOver,
            onMouseLeave: this.handleMouseLeave,
            onMouseMove: this.handleMouseMove,
            className: className,
            style: style
          },
          children
        )
      );
    }
  }]);
  return Tooltip;
}(Component);

Tooltip.propTypes = {
  disable: PropTypes.bool,
  isRevert: PropTypes.bool,
  offset: PropTypes.number,
  tooltipElement: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};

export default Tooltip;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 22
// module chunks = 0